import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#1C1B1F",
  d: "M1.5 12c-.417 0-.77-.146-1.062-.438A1.444 1.444 0 0 1 0 10.5v-9C0 1.083.146.73.438.438A1.444 1.444 0 0 1 1.5 0h13c.417 0 .77.146 1.062.438.292.291.438.645.438 1.062v9c0 .417-.146.77-.438 1.062A1.444 1.444 0 0 1 14.5 12h-13ZM8 7 1.5 3.271V10.5h13V3.271L8 7Zm0-1.771L14.5 1.5h-13L8 5.229ZM1.5 3.271V1.5v9-7.229Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };